<template>
  <v-card>
    <card-label-bar bold-text>
      Personal info
      <template v-slot:btn-text>
        <v-btn @click="editInfo" text color="blue"> Edit </v-btn>
      </template>
    </card-label-bar>

    <v-card-text>
      <v-list class="profile__info__wrap">
        <v-list-item
          v-for="(item, i) in personalInfo"
          :key="i"
          three-line
          class="info__item col-12 col-sm-6"
        >
          <v-list-item-content>
            <v-list-item-title class="caption text--secondary">
              {{ item.label }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-subtitle-2 text--primary">
              {{ item.value === "" ? "-" : item.value }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {};
  },

  computed: {
    personalInfo() {
      let user = this.$store.getters["Profile/personalInfo"];
      // user.dateOfBirth.value = user.dateOfBirth.info.value
      user.nationality.value = user.nationality.info.name;
      user.countryOfBirth.value = user.countryOfBirth.info.name;
      return user;
    },
  },

  methods: {
    toggleSideSheet(payload) {
      this.$store.dispatch("SideSheet/toggleSideSheet", payload);
    },

    editInfo() {
      this.toggleSideSheet({ isOn: true, isComponent: "personal-info-form" });
    },
  },
};
</script>

<style lang="sass" scoped>
.profile__info__wrap
  margin: -12px
  padding: 0

  .info__item
    display: inline-flex
    min-height: 32px

    .v-list-item__content
      align-content: flex-start
      align-items: flex-start
      align-self: flex-start
      padding: 0 0 8px
</style>
